import { motion } from "framer-motion";
import { useLang } from "../context/LanguageContext";

const easeElegant = [0.76, 0, 0.24, 1];

export const Manifesto = () => {
  const { t } = useLang();
  const chapters = t("manifesto.chapters") || [];

  return (
    <section
      id="about"
      className="relative bg-[#0A0A0A] py-28 md:py-40 lg:py-52"
      data-testid="manifesto-section"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16">
        {/* Header */}
        <div className="grid md:grid-cols-12 gap-8 md:gap-12 mb-24 md:mb-36">
          <div className="md:col-span-4">
            <div className="flex items-center gap-4 mb-8">
              <span className="block h-px w-12 bg-[#C5A059]" />
              <span className="overline">{t("manifesto.overline")}</span>
            </div>
            <span className="chapter-num text-[#C5A059] text-lg tracking-[0.3em]">— § —</span>
          </div>
          <div className="md:col-span-8">
            <motion.h2
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-15% 0px" }}
              transition={{ duration: 1.2, ease: easeElegant }}
              className="font-serif text-[#F4F4F0] text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight max-w-[22ch]"
              data-testid="manifesto-title"
            >
              {t("manifesto.title")}
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-15% 0px" }}
              transition={{ duration: 1.2, delay: 0.15, ease: easeElegant }}
              className="mt-10 max-w-[62ch] text-[#A1A1AA] text-base md:text-lg leading-[1.65] font-light"
            >
              {t("manifesto.intro")}
            </motion.p>
          </div>
        </div>

        {/* Chapters */}
        <div className="space-y-16 md:space-y-24">
          {chapters.map((ch, i) => (
            <motion.div
              key={ch.n}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-10% 0px" }}
              transition={{ duration: 1.1, delay: i * 0.05, ease: easeElegant }}
              className="grid md:grid-cols-12 gap-6 md:gap-12 border-t border-white/10 pt-10 md:pt-14"
              data-testid={`manifesto-chapter-${ch.n}`}
            >
              <div className="md:col-span-2">
                <span className="chapter-num text-5xl md:text-6xl">{ch.n}</span>
              </div>
              <div className="md:col-span-5">
                <h3 className="font-serif text-[#F4F4F0] text-3xl md:text-4xl font-light leading-tight tracking-tight">
                  {ch.title}
                </h3>
                <p className="mt-6 text-[#A1A1AA] text-base leading-[1.65] font-light max-w-[50ch]">
                  {ch.body}
                </p>
              </div>
              <div className="md:col-span-5 md:pl-8 md:border-l md:border-white/10 flex flex-col justify-between">
                <div>
                  <span className="overline !text-[#52525B]">
                    {ch.statLabel}
                  </span>
                  <div className="mt-3 font-serif text-[#C5A059] italic text-6xl md:text-7xl font-light leading-none tracking-tight">
                    {ch.stat}
                  </div>
                </div>
                <div className="mt-6 font-mono-ish text-xs tracking-[0.24em] uppercase text-[#52525B]">
                  Chapter {ch.n} · Felica Method
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
